import React from 'react';
import { useParams } from 'react-router-dom';
import UserAddingRoleByToken from '../addUserPage/userAddingRoleByToken';
import EventChoosingEntry from './EventChoosingEntry';

// Opaque event credentials are resolved against Pub metadata by the backend.
// Historical invitation JWTs continue through the unchanged individual component.
export default function UserChoosingEntry(props) {
  const { token } = useParams();
  return /^[a-f0-9]{64}$/.test(token || '') ? <EventChoosingEntry {...props} /> : <UserAddingRoleByToken {...props} />;
}
